<template>
    <el-table
        :data="signInTable"
        border
        class="performanceSignInTable"
        :height="320"
    >
        <el-table-column
            label="商品编码"
            prop="itemCode"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="商品名称"
            prop="itemName"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="实收数量"
            prop="realReceiveCount"
            show-overflow-tooltip
            align="center"
        ></el-table-column>
        <el-table-column
            label="拒收总数"
            prop="rejectQty"
            show-overflow-tooltip
            align="center"
        ></el-table-column>
        <el-table-column
            label="正品拒收"
            prop="goodrejectQty"
            show-overflow-tooltip
            align="center"
        ></el-table-column>
        <el-table-column
            label="箱损拒收"
            prop="packingDmgRejectQty"
            show-overflow-tooltip
            align="center"
        ></el-table-column>
        <el-table-column
            label="机损拒收"
            prop="machineDmgRejectQty"
            show-overflow-tooltip
            align="center"
        ></el-table-column>
        <el-table-column
            label="短少数量"
            prop="shortQty"
            show-overflow-tooltip
            align="center"
        ></el-table-column>
        <el-table-column
            label="上游商品编号"
            prop="upperItemCode"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="上游商品行号"
            prop="upperLineNo"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="商品状态"
            prop="itemStatusName"
            show-overflow-tooltip
            align="center"
        ></el-table-column>
    </el-table>
</template>
<script>
export default {
    name: 'signInTable',
    props: {
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            signInTable: []
        };
    },
    methods: {
        /**
         * @description 初始化用户签收表格数据
         * @param {Object} data 接口返回的用户表格数据
         */
        async initTableData(data) {
            data.forEach(item => {
                item.realReceiveCount = this.formatFloat2Number(item.realReceiveCount);
                item.shortQty = this.formatFloat2Number(item.shortQty);
                item.goodrejectQty = this.formatFloat2Number(item.goodrejectQty);
                item.packingDmgRejectQty = this.formatFloat2Number(item.packingDmgRejectQty);
                item.machineDmgRejectQty = this.formatFloat2Number(item.machineDmgRejectQty);
                item.rejectQty = (+item.goodrejectQty || 0) + (+item.packingDmgRejectQty || 0) + (+item.machineDmgRejectQty || 0);
                item.itemStatusName = this.getStatusName(this.dictData.O_ITEM_STATUS, item.itemStatus);
            });
            this.signInTable = data;
        },
        /**
         * 1. 根据后台数据， 分割小数点， 去整数部分
         * @param {*} num
         */
        formatFloat2Number(num) {
            if (!num) return 0;
            return (num + '').split('.')[0];
        },
        getStatusName(dicObj, v) {
            return dicObj[v] || v;
        }
    }
};
</script>
